var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"matter-view",attrs:{"tabindex":"1"},on:{"mousedown":_vm.mDown,"mouseup":_vm.mUp,"blur":_vm.setBlur}},[_c('div',{attrs:{"id":"testLabel"},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("돌아가기")]),_c('div',{attrs:{"id":"canvas-test"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }